import React from 'react';
import { observer } from 'mobx-react-lite';
import { Card } from 'app/components/common/Card';
import { CampaignStatusSelect } from 'app/components/CampaignStatusSelect';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { UserRoles } from 'src/types/user';
import { CampaignStatusColor, CampaignStatusTitle } from 'app/utils/campaignStatusHelpers';
import { StatusIndicator } from 'app/components/common/StatusIndicator';
import { CardProperty } from 'app/components/common/CardProperty';
import { CampaignViewModel } from 'app/viewModels/components/CampaignViewModel';
import { CampaignUpdateStatusModal } from 'app/components/CampaignUpdateStatusModal';
import { formateDate } from 'app/utils/formateDate';
import { Routes } from 'src/types/routes';

type Props = {
    campaignId: string,
    userRole: UserRoles,
};

export const CampaignCard = observer(({ campaignId, userRole }: Props) => {
    const model = useModelWithArguments(CampaignViewModel, campaignId);
    const {
        id,
        status,
        plan,
        orderNumber,
        authorName,
        assetName,
        createAt,
        openUpdateStatusModal,
    } = model;

    const formatedCreateAt = createAt ? formateDate(createAt) : '-';
    const campaignOrderNumber = orderNumber ? `#${orderNumber}` : '#';
    const campaignAssetAuthor = authorName || '-';
    const campaignAssetName = assetName || '-';
    const campaignPlan = plan?.toLowerCase() || '-';

    const isAdmin = userRole === UserRoles.Admin;

    return isAdmin
        ? (
            <>
                <Card
                    to={Routes.Dashboard.CampaignInnerPage(id || campaignId)}
                    title={campaignAssetAuthor}
                    subtitle={campaignAssetName}
                    onClickBtn={() => { /* */ }}
                    isActiveHeader
                >
                    <CardProperty title="Order #">
                        <span className="p1-regular dark-violet">{campaignOrderNumber}</span>
                    </CardProperty>
                    <CardProperty title="Order date">
                        <span className="p1-regular dark-violet">{formatedCreateAt}</span>
                    </CardProperty>
                    {status && (
                        <CardProperty title="Status">
                            <CampaignStatusSelect currentStatus={status} onSelectStatus={openUpdateStatusModal}/>
                        </CardProperty>
                    )}
                </Card>
                <CampaignUpdateStatusModal model={model}/>
            </>
        )
        : (
            <Card
                to={Routes.Dashboard.CampaignInnerPage(id || campaignId)}
                title={campaignAssetAuthor}
                subtitle={campaignAssetName}
                onClickBtn={() => { /* */ }}
                isActiveHeader
            >
                <CardProperty title="Order #">
                    <span className="p1-regular dark-violet">{campaignOrderNumber}</span>
                </CardProperty>
                <CardProperty title="Order date">
                    <span className="p1-regular dark-violet">{formatedCreateAt}</span>
                </CardProperty>
                <CardProperty title="Plan">
                    <span className="p1-regular dark-violet cap-text">{campaignPlan}</span>
                </CardProperty>
                {status && (
                    <CardProperty title="Status">
                        <StatusIndicator text={CampaignStatusTitle[status]} indicatorColor={CampaignStatusColor[status]} />
                    </CardProperty>
                )}
            </Card>
        );
});
